import { render } from "./PfOptionSelect.vue?vue&type=template&id=25cd0f43"
import script from "./PfOptionSelect.vue?vue&type=script&lang=js"
export * from "./PfOptionSelect.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__